import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { TextField, Alert, Typography, Box, useTheme, useMediaQuery, InputAdornment, IconButton } from "__barrel_optimize__?names=Alert,Box,IconButton,InputAdornment,TextField,Typography,useMediaQuery,useTheme!=!@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { tokens } from "../application/theme";
import { useTranslation } from "../../i18n/client";
import ReusableButton from "../application/components/ReusableButton";
import { AuthApi } from "../../../apis/auth";
import { isAxiosError } from "axios";
export const ResetPasswordForm = (props)=>{
    const [password, setPassword] = useState("");
    const [repeatPassword, setRepeatPassword] = useState("");
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("info");
    const [passwordError, setPasswordError] = useState(false);
    const [passwordErrorText, setPasswordErrorText] = useState("");
    const [repeatPasswordError, setRepeatPasswordError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);
    const router = useRouter();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const { t } = useTranslation(props.lng, "signup");
    const searchParams = useSearchParams();
    const token = searchParams === null || searchParams === void 0 ? void 0 : searchParams.get("token");
    const handleSubmit = async (event)=>{
        event.preventDefault();
        if (!repeatPasswordError) {
            setMessage("");
            setMessageType("info");
            setLoading(true);
            try {
                await AuthApi.resetPassword({
                    token: token,
                    password: password
                });
                router.push("/api/auth/login");
            } catch (error) {
                var _error_response, _error_response_data, _error_response1;
                if (isAxiosError(error) && ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 400 && ((_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : (_error_response_data = _error_response1.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) === "Password reset is only available for credentials accounts.") {
                    setMessage(t("passwordResetCredentialsOnly"));
                } else {
                    setMessage(t("signup_error_general"));
                }
                setMessageType("error");
                setLoading(false);
            }
        }
    };
    const validatePassword = (password)=>{
        const minLength = 8;
        const hasUppercase = /[A-Z]/.test(password);
        const hasLowercase = /[a-z]/.test(password);
        const hasNumber = /[0-9]/.test(password);
        const hasSpecialChar = /[!@#$%^&*]/.test(password);
        if (password.length < minLength) {
            return t("pass_validation_8") //'Password must be at least 8 characters long.';
            ;
        }
        if (!hasUppercase) {
            return t("pass_validation_upper") //'Password must contain at least one uppercase letter.';
            ;
        }
        if (!hasLowercase) {
            return t("pass_validation_lower") //'Password must contain at least one lowercase letter.';
            ;
        }
        if (!hasNumber) {
            return t("pass_validation_number") //'Password must contain at least one number.';
            ;
        }
        if (!hasSpecialChar) {
            return t("pass_validation_character") //'Password must contain at least one special character (!@#$%^&*).';
            ;
        }
        return "";
    };
    const handleChangePassword = (event)=>{
        event.preventDefault();
        setPassword(event.target.value);
        setMessage("");
        const passwordError = validatePassword(event.target.value);
        if (passwordError) {
            setPasswordError(true);
            setPasswordErrorText(passwordError);
        } else {
            setPasswordError(false);
            setPasswordErrorText("");
        }
    };
    const handleChangeRepeatPassword = (event)=>{
        event.preventDefault();
        setRepeatPassword(event.target.value);
        setMessage("");
        setRepeatPasswordError(password !== event.target.value);
    };
    return /*#__PURE__*/ _jsx(Box, {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        sx: {
            backgroundColor: "#F3F5FD"
        },
        children: /*#__PURE__*/ _jsxs(Box, {
            width: "100%",
            maxWidth: isMobile ? 320 : 501,
            p: "30px",
            borderRadius: "20px",
            sx: {
                backgroundColor: "#FFF"
            },
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "h3",
                    component: "h1",
                    style: {
                        textAlign: "center",
                        marginBottom: "20px"
                    },
                    children: t("new_password")
                }),
                /*#__PURE__*/ _jsxs("form", {
                    onSubmit: handleSubmit,
                    style: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ _jsx(TextField, {
                            label: t("new_password"),
                            type: showPassword ? "text" : "password",
                            value: password,
                            onChange: handleChangePassword,
                            variant: "outlined",
                            margin: "normal",
                            fullWidth: true,
                            required: true,
                            color: passwordError ? "error" : "success",
                            error: passwordError,
                            helperText: passwordErrorText,
                            InputProps: {
                                endAdornment: /*#__PURE__*/ _jsx(InputAdornment, {
                                    position: "end",
                                    children: /*#__PURE__*/ _jsx(IconButton, {
                                        "aria-label": showPassword ? t("hidePassword") : t("showPassword"),
                                        onClick: ()=>setShowPassword((prev)=>!prev),
                                        onMouseDown: (event)=>event.preventDefault(),
                                        edge: "end",
                                        children: showPassword ? /*#__PURE__*/ _jsx(VisibilityOff, {}) : /*#__PURE__*/ _jsx(Visibility, {})
                                    })
                                })
                            }
                        }),
                        /*#__PURE__*/ _jsx(TextField, {
                            label: t("repeat_new_password"),
                            type: showRepeatPassword ? "text" : "password",
                            value: repeatPassword,
                            onChange: handleChangeRepeatPassword,
                            variant: "outlined",
                            margin: "normal",
                            fullWidth: true,
                            required: true,
                            color: repeatPasswordError ? "error" : "success",
                            error: repeatPasswordError,
                            helperText: repeatPasswordError ? t("passwordsAreNotEqual") : "",
                            InputProps: {
                                endAdornment: /*#__PURE__*/ _jsx(InputAdornment, {
                                    position: "end",
                                    children: /*#__PURE__*/ _jsx(IconButton, {
                                        "aria-label": showRepeatPassword ? t("hidePassword") : t("showPassword"),
                                        onClick: ()=>setShowRepeatPassword((prev)=>!prev),
                                        onMouseDown: (event)=>event.preventDefault(),
                                        edge: "end",
                                        children: showRepeatPassword ? /*#__PURE__*/ _jsx(VisibilityOff, {}) : /*#__PURE__*/ _jsx(Visibility, {})
                                    })
                                })
                            }
                        }),
                        /*#__PURE__*/ _jsx(ReusableButton, {
                            name: t("reset"),
                            backgroundColor: colors.button.main,
                            backgroundColorOnHover: colors.button.mainOnHower,
                            type: "submit",
                            color: "#FFF",
                            width: "100%",
                            paddingTop: "15px",
                            loading: loading
                        }),
                        message && /*#__PURE__*/ _jsx(Alert, {
                            severity: messageType,
                            style: {
                                marginTop: "20px"
                            },
                            children: message
                        })
                    ]
                })
            ]
        })
    });
};
